<template>
  <div class="page">
    <loader v-if="dataLoading" />

    <div class="flex justify-content-center">
      <div class="grid">
        <div class="grid">
          <div class="col p-as-end">
            <i></i><br>
            <span class="p-input-icon-left">
              <i class="pi pi-filter" />
              <input-text 
                v-model="filter"
                type="text" 
                placeholder="Search" 
              />
            </span>
          </div>

          <div class="col">
            <i></i><br>
            <prime-button icon="pi pi-filter-slash" class="p-button-rounded" @click="filter=''" />
          </div>
        </div>
      </div>
    </div>

    <accordion :multiple="true" >
      <accordion-tab  v-for="(item, index) in data.filtered" :key="index">
        <template #header>
          <span>{{ item.cliente }} -</span>&nbsp;
          <span>({{ currencyFormatter.format( (item.totale !== null)? item.totale: 0 ) }})</span>
        </template>

        <data-table :value="item.fatture" v-model:selection="data.selectedInPreavviso[index]" dataKey="numero" responsiveLayout="scroll" >
          <column selectionMode="multiple" headerStyle="width: 3em"></column>
          <column field="numero" header="Numero"></column>
          <column field="data_emissione" header="Data Emissione">
            <template #body="{data}">
              {{ (data.data_emissione !== null)? moment(data.data_emissione).format('DD/MM/YYYY'): '' }}
            </template>
          </column>
          <column field="data_scadenza" header="Data Scadenza">
            <template #body="{data}">
              {{ (data.data_scadenza !== null)? moment(data.data_scadenza).format('DD/MM/YYYY'): '' }}
            </template>
          </column>
          <column field="saldo" header="Importo Dovuto">
            <template #body="{data}">
              {{currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 )}}
            </template>
          </column>
          <column field="data_preavviso" header="Data Preavviso">
            <template #body="{data}">
              {{ (data.data_preavviso !== null)? moment(data.data_preavviso).format('DD/MM/YYYY'): '' }}
            </template>
          </column>
        </data-table>

        <div class="p-d-flex p-p-3 card">
          <prime-button label="PDF" icon="pi pi-file-pdf" class="mb-auto" @click="onGetPdfButton(index)" />
        </div>

      </accordion-tab>
    </accordion>
    
  </div>
</template>

<script>
import moment from 'moment'
import slugify from 'slugify'

import Service from '@/services/ask-management/preavvisi-fatture-clienti-service.js'

import Loader from '@/components/Loader.vue'
import PrimeButton from 'primevue/button'

export default { 
  components: {
    Loader,
    PrimeButton,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      dataLoading: false,
      filter: '',

      data: {
        fattureInPreavviso: [],
        selectedInPreavviso: [],

        filtered: [],
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    
    this.getAllFattureInPreavviso()
  },

  methods:{

    onGetPdfButton(index){
      this.service.downloadFilePreavvisiZip({
        'fattura_vendita.numeri': this.data.selectedInPreavviso[index].map((el) => el.numero)
      })
    },

    /////

    navigateToTab(href){
      window.open(href, '_blank')
    },

    applyFilter(filter){
      const length = filter.trim().length
      if(length == 0){
        this.data.selectedInPreavviso = []
        this.data.filtered = [...this.data.fattureInPreavviso]
        return
      }
      if(length > 2){
        this.data.selectedInPreavviso = []
        this.data.filtered = this.data.fattureInPreavviso.filter( (el) => el.cliente.toUpperCase().indexOf(filter.toUpperCase()) >= 0 )
        return
      }
    },

    getAllFattureInPreavviso(){
      this.dataLoading = true
      this.service.getAllFattureInPreavviso({}).then((res) => {
        this.data.fattureInPreavviso = Object.entries(res.item).map((el) => {
          return {
            slug: slugify(el[0], {lower: true}),
            cliente: el[0],
            totale: el[1].totale,
            fatture: el[1].fatture
          }
        })

        this.data.selectedInPreavviso = []
        this.data.filtered = [...this.data.fattureInPreavviso]
      })
      .finally(() =>{
        this.dataLoading = false
      })
    },

  },

  computed:{
    
  },

  watch: {
    filter(newVal) {
      this.applyFilter(newVal)
    },
  },
}
</script>

<style scoped>
.box-center{
  text-align: center;
}
</style>
